import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StyledIconButton = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  width: '25px',
  height: '25px',
});
